import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  
  constructor(readonly toastr: ToastrService,
              readonly translate: TranslateService
  ) { }

  showSuccess(message, title,time = 50000){
    if (!message) return;
    this.toastr.success(message, title, {
      enableHtml : true,
      closeButton: true
    })
  }

  showError(message, title, time = 9000000){
    if (!message) return;
    this.toastr.error(message, title, {
      enableHtml : true,
      closeButton: true,
      timeOut: time
    })
  }

  showInfo(message, title, time= 9000){
    if (!message) return;
    this.toastr.info(message, title, {
      enableHtml : true,
      closeButton: true,
      timeOut :  time
    })
  }

  showWarning(message, title, time= 5000){
    if (!message) return;
    this.toastr.warning(message, title, {
      enableHtml : true,
      closeButton: true
    })
  }

  showHTMLMessage(message, title,time= 1000){
    if (!message) return;
    this.toastr.success(message, title, {
      enableHtml : true,
      closeButton: true,
      timeOut: time
    })
  }

  showSuccessWithTimeout(message, title, timespan){
    if (!message) return;
    this.toastr.success(message, title ,{
      enableHtml : true,
      timeOut :  timespan,
      closeButton: true,
    })
  }

  showSuccessMessage(message,title,time = 1000) {
    if (!message) return;
    this.toastr.success("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-check-circle'></i></p><p class='col'> " + `${message}` + "</p></div>",
        title, {
      enableHtml: true,
      closeButton: true,
      timeOut: time
    })
  }

  showPersistentSuccessMessage(message: string, title = '') {
    if (!message) return;
    // preventDuplicates is configured globally. Add a non-visible token so each queued
    // export remains independently visible while preserving the displayed message.
    const uniqueMessage = `${message}<span class="d-none">${Date.now()}</span>`;
    this.toastr.success("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-check-circle'></i></p><p class='col'> " + uniqueMessage + "</p></div>",
      title, {
        enableHtml: true,
        closeButton: true,
        timeOut: 0
      });
  }

  showLocalSuccessMessage(translationKey: string,title,time = 1000) {
    this.translate.get(translationKey).subscribe((translatedMessage: string) => {

      const messageHtml = `
        <div class='row'>
          <p class='col-1 d-flex align-items-center'>
            <i class='fa fa-check-circle'></i>
          </p>
          <p class='col'>${translatedMessage}</p>
        </div>`;

      // Call the toastr service to show the success message with HTML
      this.toastr.success(messageHtml, title, {
        enableHtml: true,
        closeButton: true,
        timeOut: time
      });
    });
  }

  showErrorMessage(message, time = 5000) {
    if (!message) return;
    
    const uniqueMessage = `${message}<span class="d-none">${Date.now()}_${Math.random()}</span>`;
    this.toastr.error("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + uniqueMessage + "</p></div>", "",{
      enableHtml : true,
      closeButton: true,
      timeOut: time
    });
  }
  
}
